<template>
  <div>
    <div>
      <el-row type="flex" justify="space-between">
        <strong>{{ title }}</strong>
      </el-row>
    </div>
    <el-table
      v-show="title!='流水'"
      ref="multipleTable"
      :data="data"
      tooltip-effect="dark"
      height="550"
    >
      <el-table-column
        v-if="title=='资料库'"
        key="1"
        prop="productionLicense"
        label="生产许可证"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="brand"
        label="品牌"
        show-overflow-tooltip
        align="center"
        key="2"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称"
        show-overflow-tooltip
        align="center"
        key="3"
      >
      </el-table-column>

      <el-table-column
        prop="manufacturer"
        label="生产厂家"
        show-overflow-tooltip
        align="center"
        key="4"
      >
      </el-table-column>
      <el-table-column
        v-if="show == '库存'"
        prop="numFormat"
        label="实际库存数量"
        show-overflow-tooltip
        align="center"
        key="5"
      >
      </el-table-column>
      <el-table-column
        v-if="show == '库存'"
        prop="remainNum"
        label="可用库存数量"
        show-overflow-tooltip
        align="center"
        key="6"
      >
        <template slot-scope="scope">
          {{scope.row.remainNum | remainNumFormat(scope.row)}}
        </template>
      </el-table-column>
      <el-table-column prop="weightUnit" label="包装净含量" align="center" key="7">
      </el-table-column>
      <el-table-column v-if="title !== '流水'" label="操作" key="8">
        <template slot-scope="scope">
          <el-link
            :type="title === '库存' ? 'danger' : 'primary'"
            @click="clickRow(scope.row)"
            style="padding: 4px"
            >{{
              title === '资料库' ? '采购登记' : '核销登记'
            }}</el-link
          >
          <el-link
            v-if="title === '库存'"
            type="primary"
            @click="running(scope.row)"
            style="padding: 4px"
            >流水情况</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-show="title== '流水'"
      ref="multipleTable"
      :data="inputsRunning"
      tooltip-effect="dark"
      height="550"
    >
      <el-table-column
        prop="createTime"
        label="日期时间"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">{{ new Date(scope.row.createTime).format('yyyy-MM-dd hh:mm:ss')}}</template>
      </el-table-column>
      <el-table-column
        prop="brand"
        label="品牌"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="num"
        label="数量"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.numFormat | numFormat(scope.row.direction)}}
        </template>
      </el-table-column>
      <el-table-column
        prop="weightUnit"
        label="包装形式"
        show-overflow-tooltip
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="flag"
        label="事由说明"
        show-overflow-tooltip
        align="center"
      >
        <template slot-scope="scope">
          {{scope.row.flag | flagFormat}}
        </template>
      </el-table-column>
      <el-table-column
        prop="userName"
        label="登记人"
        show-overflow-tooltip
        align="center"
        width="90"
      >
      </el-table-column>
    </el-table>
    <InputsDialog
      :data="rowData"
      :visible.sync="showDialog"
      :title="dialogTitle"
      :inputsInvoiceOfId="inputsInvoiceOfId"
      @refreshData="refreshData"
    />
  </div>
</template>
<script>
  import { invoiceListById } from '@/api/inputs-invoice.js'
export default {
  components: { InputsDialog: () => import('./InputsDialog') },
  props: ['data', 'title', 'writeOff','inputsRunning'],
  data() {
    return {
      rowData: undefined, //选中的数据
      showDialog: false, //对话弹窗
      dialogTitle: undefined, //弹窗标题
      showBtn: false, //采购登记按钮是否可以点击
      inputsInvoiceOfId:[]
    }
  },
  filters:{
    numFormat(val,direction) {
      if(direction=="in") {
        return '+'+val
      }else{
        return '-'+val
      }
    },
    flagFormat(val) {
      if(val==1){
        return '正常使用消耗'
      } else if(val==2) {
        return '核减消耗'
      }else if(val==3) {
        return '采购入库'
      }
    },
    remainNumFormat(val,obj) {
      return val+obj.packagingForm
    }
  },
  computed: {
    show() {
      return this.title
    },
  },
  watch: {
    title(value) {
      this.disabledBtn = true
    },
    writeOff(value) {
      this.showBtn = true
    },
  },
  methods: {
    // 行点击
    clickRow(value) {
      if (this.title === '库存') {
        this.dialogTitle = '核销登记'
      } else {
        this.dialogTitle = '采购登记'
      }
      this.rowData = value
      this.showDialog = true
    },
    running(row) {
      this.dialogTitle =  `${row.name}的流水情况`
      this.showDialog = true
      let option={
        pageNum:this.pageNum,
        pageSize:this.pageSize
      }
      invoiceListById(this.$store.getters.currentEnterprise.id,row.id,option).then(data=>{
        this.total = data.data.total
        this.inputsInvoiceOfId=data.data.list.map(item=>{
          return {
            weightUnit:
              item.packingWeight +
              item.unit +
              (item.packagingForm === '' ? '' : '/' + item.packagingForm),
            disabled: false,
            numFormat:
              item.num + item.packagingForm+`,合计${item.num*item.packingWeight}${item.unit}`,
            ...item,
          }
        })
      })
    },
    // 刷新数据
    refreshData(value) {
      this.$emit('refreshData', value)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/resource/inputs/InputsTable.vue